import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { WarehouseService } from '../services';

const useStoreUpdateVisible = (id: string) => {
  const { t } = useTranslation(['warehouse', 'errors']);

  const {
    mutateAsync,
    isPending: isLoading,
    data,
  } = useMutation((visible: boolean) => WarehouseService.updateVisibility(id, { visible }), {
    onSuccess: () => {
      toast.success(t('provider:visibilitySuccessUpdate'));
    },
    onError: () => {
      toast.error(t('generalErrorMessage', { ns: 'errors' }));
    },
  });

  return {
    updateVisible: mutateAsync,
    isLoading,
    value: data?.data?.visible,
  };
};

export default useStoreUpdateVisible;
